import { RouteRecordRaw } from "vue-router"

// ====================================
// Module data
// ====================================
// Routes fiche bâtiment / fiche source sous :_id : voir @core/router/building.routes.ts et @core/router/source.routes.ts

export const routes = [] as RouteRecordRaw[]
